const IconMap = {
  'actions-arrow': (props) => (
    <svg width={12} height={12} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.138 1.595 3.546 9.187.862 6.503a.325.325 0 0 0-.46 0l-.307.307a.325.325 0 0 0 0 .46l3.221 3.22a.325.325 0 0 0 .46 0l8.129-8.128a.325.325 0 0 0 0-.46l-.307-.307a.325.325 0 0 0-.46 0z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
  'actions-bars': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 13.2v1.6H0v-1.6h16zm0-5.6v1.6H0V7.6h16zM16 2v1.6H0V2h16z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'actions-check': (props) => (
    <svg width={16} height={11} viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m1.38 4.713 4.507 4.508L14.107 1"
        fillRule="nonzero"
        fill="none"
        strokeLinecap="square"
        strokeWidth={1.5}
        stroke="currentColor"
      />
    </svg>
  ),
  'actions-close': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M8 6.609 14.609 0 16 1.391 9.391 8 16 14.609 14.609 16 8 9.391 1.391 16 0 14.609 6.609 8 0 1.391 1.391 0z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'actions-email': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 2v11.79H0V2h16zm-1.348 4.246L8.006 9.661 1.347 6.339v6.103h13.306l-.001-6.196zm0-2.899H1.348v1.486l6.65 3.318 6.655-3.42V3.347z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'actions-notes': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M-953-219H487v3730H-953z" />
        <path
          d="M16 11.29V1.713C16 .767 15.232 0 14.286 0H1.714C.767 0 0 .767 0 1.714v12.571C0 15.232.767 16 1.714 16h9.576c.455 0 .89-.181 1.212-.503l2.996-2.995c.321-.322.502-.758.502-1.213zm-4.306 3.4a.567.567 0 0 1-.265.15v-3.412h3.41a.567.567 0 0 1-.15.266l-2.995 2.995zm3.163-12.976v8.571h-3.714a.857.857 0 0 0-.857.857v3.715H1.714a.571.571 0 0 1-.571-.572V1.715c0-.316.256-.572.571-.572h12.572c.315 0 .571.256.571.571z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'actions-notification': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 15c-.552 0-1-.45-1-1H6c0 1.102.898 2 2 2 1.103 0 2-.898 2-2H9c0 .55-.448 1-1 1zm6.543-4.537c-.873-.832-1.542-1.703-1.542-4.654 0-2.487-1.98-4.515-4.5-4.76V.5a.5.5 0 1 0-1 0v.549c-2.521.245-4.502 2.273-4.502 4.76 0 2.951-.669 3.822-1.542 4.654a1.454 1.454 0 0 0-.352 1.6c.228.57.775.937 1.395.937h11c.62 0 1.168-.368 1.395-.937a1.454 1.454 0 0 0-.352-1.6zM13.5 12h-11c-.445 0-.667-.515-.354-.813C3.236 10.15 4 8.99 4 5.81 3.999 3.704 5.789 2 8 2c2.211 0 4.001 1.704 4.001 3.81 0 3.167.757 4.334 1.853 5.377.314.3.089.813-.354.813z"
        fill="#000"
        fillRule="nonzero"
      />
    </svg>
  ),
  'actions-phone': (props) => (
    <svg width={17} height={16} viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M4.482 0c-.321 0-.638.115-.902.327l-.038.019-.02.019-1.918 1.979.02.019a1.928 1.928 0 0 0-.519 2.075c.002.005-.002.014 0 .019.52 1.491 1.852 4.37 4.452 6.974 2.61 2.612 5.524 3.892 6.966 4.457h.02c.745.25 1.553.072 2.13-.423l1.937-1.94c.509-.51.509-1.393 0-1.902l-2.494-2.498-.02-.038c-.508-.51-1.41-.51-1.918 0l-1.229 1.23a9.933 9.933 0 0 1-2.513-1.73C7.43 7.627 6.917 6.522 6.728 6.09l1.228-1.23c.515-.516.525-1.376-.02-1.882l.02-.02-.058-.057L5.442.365l-.02-.02-.038-.018A1.446 1.446 0 0 0 4.482 0zm0 1.23c.046 0 .092.021.135.057l2.456 2.517.058.057c-.005-.004.036.06-.039.135L5.557 5.533l-.288.269.135.384s.705 1.89 2.187 3.304l.134.116c1.428 1.304 3.11 2.017 3.11 2.017l.383.173 1.823-1.825c.106-.106.086-.106.192 0l2.514 2.516c.105.106.105.068 0 .173l-1.88 1.883c-.284.242-.584.293-.941.173-1.391-.548-4.095-1.736-6.505-4.15-2.43-2.432-3.7-5.192-4.165-6.532-.093-.25-.026-.62.192-.807l.039-.038 1.861-1.902a.215.215 0 0 1 .134-.057z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'actions-search': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M6.366 0a6.366 6.366 0 0 1 5.084 10.2L16 14.75 14.75 16l-4.55-4.55A6.366 6.366 0 1 1 6.366 0zm0 1.768a4.598 4.598 0 1 0 0 9.196 4.598 4.598 0 0 0 0-9.196z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'actions-share': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M-953-516H487v3730H-953z" fill="#FFF" />
        <path
          d="m15.692 6.454-4.889-5.11c-.686-.718-1.914-.24-1.914.768V4.56C4.293 4.615 0 5.447 0 10.2c0 2.638 1.551 4.173 2.476 4.849.673.492 1.612-.139 1.38-.959-1.052-3.732.743-4.146 5.033-4.197v2.44c0 1.007 1.227 1.486 1.914.768l4.889-5.11c.41-.43.41-1.107 0-1.537zm-.643.922-4.888 5.11a.222.222 0 0 1-.383-.153V9C5.017 9 1.575 9.27 3 14.325 2 13.593.889 12.266.889 10.2c0-4.445 4.524-4.756 8.889-4.756V2.111c0-.202.246-.297.383-.153l4.888 5.11a.222.222 0 0 1 0 .308z"
          fill="#000"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'actions-paper-plane': (props) => (
    <svg width={16} height={16} viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M307 356L556.1 106.8L394.5 558.1C394.1 559.2 393 560 391.8 560C390.6 560 389.6 559.3 389.2 558.2L307 356zM533.5 84.2L284.4 333.4L82.1 251.2C81 250.8 80.3 249.7 80.3 248.6C80.3 247.4 81.1 246.3 82.2 245.9L533.5 84.2zM70.1 280.8L275.9 364.4L359.5 570.2C364.8 583.3 377.6 591.9 391.8 591.9C406.5 591.9 419.6 582.7 424.6 568.8L602.6 72C606.1 62.2 603.6 51.4 596.3 44C589 36.6 578.1 34.2 568.3 37.7L71.4 215.7C57.5 220.7 48.3 233.8 48.3 248.5C48.3 262.7 56.9 275.5 70 280.8z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
  'actions-sort-by': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M15.29 5.388 12.322.49a1.056 1.056 0 0 0-1.782 0L7.569 5.388c-.396.652.099 1.469.89 1.469h5.94c.792 0 1.286-.817.89-1.47zm-6.583.326 2.722-4.49 2.723 4.49H8.707zm.15 10.285H14a.857.857 0 0 0 .858-.857V10A.857.857 0 0 0 14 9.142H8.858A.857.857 0 0 0 8 10v5.142c0 .474.383.857.857.857zm.287-5.714h4.57v4.572h-4.57v-4.572zm-2.61 1.842a.426.426 0 0 0-.604-.004l-1.928 1.881V.286A.286.286 0 0 0 3.716 0h-.572a.286.286 0 0 0-.286.286v13.71L.932 12.128a.429.429 0 0 0-.605 0l-.201.202a.429.429 0 0 0 0 .607l3.002 2.94a.426.426 0 0 0 .603 0l3-2.94a.429.429 0 0 0 .003-.608l-.2-.201z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'actions-trash': (props) => (
    <svg width={14} height={14} viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.969 11.813h.437c.121 0 .219-.098.219-.22V4.157a.219.219 0 0 0-.219-.218H8.97a.219.219 0 0 0-.219.218v7.438c0 .12.098.219.219.219zm-4.375 0h.437c.121 0 .219-.098.219-.22V4.157a.219.219 0 0 0-.219-.218h-.437a.219.219 0 0 0-.219.218v7.438c0 .12.098.219.219.219zM12.906 1.75h-2.844L9.145.525A1.313 1.313 0 0 0 8.094 0H5.906c-.413 0-.802.195-1.05.525L3.938 1.75H1.094a.219.219 0 0 0-.219.219v.437c0 .121.098.219.219.219h.656v10.063c0 .724.588 1.312 1.313 1.312h7.874c.725 0 1.313-.588 1.313-1.313V2.626h.656c.121 0 .219-.098.219-.219V1.97a.219.219 0 0 0-.219-.219zm-7.35-.7a.44.44 0 0 1 .35-.175h2.188a.44.44 0 0 1 .35.175l.525.7H5.03l.525-.7zm5.819 11.637a.437.437 0 0 1-.438.438H3.064a.437.437 0 0 1-.438-.438V2.626h8.75v10.063zm-4.594-.874h.438c.12 0 .218-.098.218-.22V4.157a.219.219 0 0 0-.218-.218H6.78a.219.219 0 0 0-.218.218v7.438c0 .12.097.219.218.219z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
  'actions-text': (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 16 16"
      width="16px"
      height="16px"
      {...props}
    >
      <path d="M4.82,7.55c0.21,0,0.38-0.07,0.52-0.21C5.48,7.2,5.55,7.03,5.55,6.82c0-0.21-0.07-0.38-0.21-0.52 C5.2,6.16,5.03,6.09,4.82,6.09c-0.21,0-0.38,0.07-0.52,0.21C4.16,6.44,4.09,6.61,4.09,6.82c0,0.21,0.07,0.38,0.21,0.52 C4.44,7.48,4.62,7.55,4.82,7.55z M8.05,7.55c0.21,0,0.38-0.07,0.52-0.21C8.71,7.2,8.78,7.03,8.78,6.82c0-0.21-0.07-0.38-0.21-0.52 C8.43,6.16,8.26,6.09,8.05,6.09S7.67,6.16,7.53,6.3C7.39,6.44,7.32,6.61,7.32,6.82c0,0.21,0.07,0.38,0.21,0.52 C7.67,7.48,7.85,7.55,8.05,7.55z M11.16,7.55c0.21,0,0.38-0.07,0.52-0.21c0.14-0.14,0.21-0.31,0.21-0.52c0-0.21-0.07-0.38-0.21-0.52 c-0.14-0.14-0.31-0.21-0.52-0.21c-0.21,0-0.38,0.07-0.52,0.21c-0.14,0.14-0.21,0.31-0.21,0.52c0,0.21,0.07,0.38,0.21,0.52 C10.78,7.48,10.95,7.55,11.16,7.55z M0.7,14.32V2.13c0-0.28,0.11-0.53,0.33-0.76C1.25,1.15,1.5,1.03,1.79,1.03h12.41 c0.28,0,0.53,0.11,0.76,0.34c0.23,0.23,0.34,0.48,0.34,0.76v9.49c0,0.28-0.11,0.53-0.34,0.76c-0.23,0.23-0.48,0.34-0.76,0.34H3.62 L1.63,14.7c-0.17,0.17-0.37,0.21-0.59,0.12C0.81,14.73,0.7,14.56,0.7,14.32z M1.79,12.99l1.37-1.37h11.04V2.13H1.79V12.99z  M1.79,2.13v10.86V2.13z" />
    </svg>
  ),
  'actions-website': (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width={16} height={16} {...props}>
      <path
        d="M459.5 152C438.1 152 417.3 158.9 400.2 171.4C388.8 159.7 375.8 149.3 361.8 140.7C388.8 117.1 423.5 104 459.5 104C541.5 104 608 170.5 608 252.5C608 291.9 592.4 329.6 564.5 357.5L485.4 436.6C457.6 464.4 419.8 480.1 380.4 480.1C298.4 480.1 231.9 413.6 231.9 331.6C231.9 313.7 235.1 296.1 241.3 279.7C245.9 267.3 259.8 261 272.2 265.6C284.6 270.2 291 284 286.4 296.4C282.2 307.5 280 319.4 280 331.6C280 387.1 325 432.1 380.5 432.1C407.1 432.1 432.7 421.5 451.5 402.7L530.6 323.6C549.4 304.6 560 279.1 560 252.5C560 197 515 152 459.5 152zM259.5 208C232.9 208 207.3 218.6 188.5 237.4L109.4 316.5C90.6 335.3 80 360.9 80 387.5C80 443 125 488 180.5 488C201.9 488 222.7 481.1 239.8 468.6C251.2 480.4 264.2 490.7 278.2 499.3C251.2 522.9 216.5 536 180.5 536C98.5 536 32 469.5 32 387.5C32 348.1 47.6 310.4 75.5 282.5L154.6 203.4C182.4 175.6 220.2 159.9 259.6 159.9C341.6 159.9 408.1 226.4 408.1 308.4C408.1 326.3 404.9 343.9 398.7 360.3C394.1 372.7 380.2 379 367.8 374.4C355.4 369.8 349 356 353.6 343.6C357.8 332.5 360 320.6 360 308.5C360 253 315 208 259.5 208z"
        fill="currentColor"
      />
    </svg>
  ),
  'actions-edit': (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width={16} height={16} {...props}>
      <path
        d="M468 96C457.3 96 447.1 100.2 439.5 107.8L381 166.3L473.7 259L532.2 200.5C539.8 192.9 544 182.7 544 172C544 161.3 539.8 151.1 532.2 143.5L496.5 107.8C488.9 100.2 478.7 96 468 96zM157 390.3L249.7 483L451 281.7L358.3 189L157 390.3zM136 414.6C134 418.3 132.4 422.3 131.2 426.4L99.5 540.5L213.6 508.8C217.7 507.7 221.7 506.1 225.4 504L136 414.6zM416.9 85.2C430.4 71.6 448.8 64 468 64C487.2 64 505.6 71.6 519.1 85.2L554.8 120.9C568.4 134.4 576 152.8 576 172C576 191.2 568.4 209.6 554.8 223.1L260.8 517.1C250.1 527.8 236.7 535.6 222.1 539.7L94.4 575.1C86.1 577.4 77.1 575.1 71 568.9C64.9 562.7 62.5 553.8 64.8 545.5L100.4 417.8C104.5 403.2 112.2 389.9 123 379.1L417 85.1z"
        fill="currentColor"
      />
    </svg>
  ),
  'arrow-default-down': (props) => (
    <svg width={15} height={22} viewBox="0 0 15 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="m12 8 1.06 1.06-5.53 5.531L2 9.061 3.06 8l4.47 4.47z" fill="currentColor" />
      </g>
    </svg>
  ),
  'arrow-default-left': (props) => (
    <svg width={15} height={22} viewBox="0 0 15 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="m6.356 11.295 4.47 4.47-1.06 1.06-5.531-5.53 5.53-5.53 1.06 1.06z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-default-right': (props) => (
    <svg width={15} height={22} viewBox="0 0 15 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="m8.705 11.295-4.47-4.47 1.06-1.06 5.53 5.53-5.53 5.53-1.06-1.06z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-default-up': (props) => (
    <svg width={15} height={22} viewBox="0 0 15 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M3.06 14.591 2 13.531 7.53 8l5.53 5.53L12 14.591l-4.47-4.47z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-large-left': (props) => (
    <svg width={15} height={48} viewBox="0 0 15 48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M1.06 23.698 15.873 8.887l-1.06-1.06-15.873 15.871L14.811 39.57l1.061-1.06z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-large-right': (props) => (
    <svg width={15} height={48} viewBox="0 0 15 48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M13.75 23.698-1.06 8.887 0 7.827l15.872 15.871L0 39.57l-1.06-1.06z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-medium-left': (props) => (
    <svg width={15} height={48} viewBox="0 0 15 48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="m4.121 24.215 9.155 9.155-1.06 1.06L2 24.215 12.215 14l1.06 1.06z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-medium-right': (props) => (
    <svg width={15} height={48} viewBox="0 0 15 48" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M11.155 24.215 2 15.061 3.06 14l10.216 10.215L3.06 34.43 2 33.37z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-small-down': (props) => (
    <svg
      height={4.5}
      width={7.5}
      viewBox="0 0 7.5 4.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.9,4.4l3.5-3.4c0.1-0.1,0.1-0.3,0-0.4c0,0,0,0,0,0L7,0.1C6.8,0,6.7,0,6.6,0.1 c0,0,0,0,0,0L3.8,2.9L0.9,0.1C0.8,0,0.7,0,0.5,0.1c0,0,0,0,0,0L0.1,0.5C0,0.7,0,0.8,0.1,0.9c0,0,0,0,0,0l3.5,3.4 C3.7,4.5,3.8,4.5,3.9,4.4L3.9,4.4z"
        />
      </g>
    </svg>
  ),
  'arrow-small-left': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="m5.599 8.433 3.44 3.47c.11.11.289.11.4 0l.463-.465a.281.281 0 0 0 0-.398L7.125 8.234 9.902 5.43a.281.281 0 0 0 0-.399l-.464-.464a.281.281 0 0 0-.398 0L5.599 8.035a.281.281 0 0 0 0 .398z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-small-right': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="m9.902 8.035-3.44-3.469a.281.281 0 0 0-.399 0L5.6 5.03a.281.281 0 0 0 0 .399l2.777 2.805L5.6 11.04a.281.281 0 0 0 0 .398l.464.464c.11.11.288.11.399 0l3.44-3.469a.281.281 0 0 0 0-.398z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'arrow-small-up': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="m7.551 6.083-3.468 3.44a.281.281 0 0 0 0 .399l.464.464c.11.11.288.11.398 0l2.806-2.778 2.805 2.778c.11.11.288.11.398 0l.465-.464a.281.281 0 0 0 0-.399l-3.47-3.44a.281.281 0 0 0-.398 0z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'filters-coming-soon': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M15.277 15.78a.747.747 0 0 0 0-1.06l-1.328-1.328a6.965 6.965 0 0 0 1.546-4.39 6.956 6.956 0 0 0-.63-2.921A3.495 3.495 0 0 0 15.998 3.5c0-1.935-1.566-3.5-3.5-3.5a3.493 3.493 0 0 0-3.184 2.047 7.118 7.118 0 0 0-1.631 0A3.493 3.493 0 0 0 4.5 0 3.498 3.498 0 0 0 1 3.5c0 1.021.437 1.94 1.134 2.58A7.002 7.002 0 0 0 1.5 9c0 1.661.581 3.19 1.547 4.39l-1.328 1.327a.747.747 0 0 0 0 1.06.747.747 0 0 0 1.059 0l1.328-1.328a7 7 0 0 0 8.78 0l1.331 1.33a.747.747 0 0 0 1.06 0zM14.06 4.746a7.02 7.02 0 0 0-3.228-2.35A1.99 1.99 0 0 1 12.5 1.5c1.103 0 2 .897 2 2 0 .471-.166.906-.438 1.246zm-11.12 0A1.98 1.98 0 0 1 2.5 3.5a2.002 2.002 0 0 1 3.668-1.103 6.988 6.988 0 0 0-3.228 2.35zM8.498 14.5c-3.04 0-5.5-2.46-5.5-5.5 0-3.03 2.45-5.5 5.5-5.5C11.543 3.5 14 5.963 14 9c0 3.04-2.46 5.5-5.5 5.5zm1.969-3.088.565-.825a.376.376 0 0 0-.096-.521L9.374 8.99V5.624A.376.376 0 0 0 9 5.25H8a.376.376 0 0 0-.375.375v4.09c0 .126.06.241.163.31l2.156 1.484a.383.383 0 0 0 .525-.097z"
          fill="currentColor"
          fillOpacity={0.85}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-floorplan': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="m8.332 7.928 7.28-3.302c.517-.235.517-1.017 0-1.251L8.332.072A.952.952 0 0 0 8 0a.952.952 0 0 0-.333.072L.387 3.374c-.516.235-.516 1.017 0 1.252l7.28 3.302a.8.8 0 0 0 .665 0zm0 4.006 7.28-3.3c.517-.234.517-1.015 0-1.25l-1.815-.822-5.051 2.29a1.793 1.793 0 0 1-1.492 0l-5.05-2.29-1.816.822c-.517.235-.517 1.016 0 1.25l7.28 3.3a.803.803 0 0 0 .664 0zm0 3.994 7.28-3.3c.517-.234.517-1.016 0-1.25l-1.808-.82-5.058 2.293a1.793 1.793 0 0 1-1.492 0l-5.057-2.293-1.81.82c-.516.234-.516 1.016 0 1.25l7.28 3.3a.803.803 0 0 0 .665 0z"
          fill="currentColor"
          fillOpacity={0.85}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-indiana': (props) => (
    <svg width={20} height={35} viewBox="0 0 20 35" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M-51-1315h1440v3730H-51z" />
        <path
          d="m6.082 1.368-1.988.655-1.696-.704-.433 18.81-.575 1.892-.079.743.757 1.394-.027.26-.147.322.261.742-.205.88-.666.605-.648 1.51-1.622 1.82-.31 2.596-.373-.039.26.741.38.34.262-.347-.195-.66 1.733-.005.027.454.402.117.184-.319-.173-.506.143-.286.453.348.649-.082.61.29 1.183.913.78-.97 1.389-.68.988 1.343.678-.717.217-.992 1.504-.705.024.49.66.52 1.126.044.474-.213.17-1.26 1.075-1.276 1.884-1.455.03-.635.595-1.365.78.458 2.67-1.41-.082-.647-.477-.839.447-.666-.224-21.508.017-.524L6.778.84z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'filters-kentucky': (props) => (
    <svg width={46} height={23} viewBox="0 0 46 23" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path
          d="M35.2467532,19.0914823 L28.0427807,19.5837121 L26.2154316,19.8649862 L20.1008403,20.2165789 L19.1871658,20.497853 L11.2452254,21.2010384 L10.9992361,20.9900828 L9.69900688,20.9900828 L10.1207028,22.1151794 L9.90985485,22.4316128 L1.72192513,22.9590018 L2.07333843,22.0097016 L2.56531704,22.326135 L2.81130634,22.1854979 L3.23300229,20.7439679 L2.881589,20.3923752 L3.23300229,19.6891899 L3.30328495,19.3727565 L2.84644767,19.0914823 L2.74102368,18.4586155 L4.14667685,17.1577226 L6.57142857,18.2125006 L7.09854851,18.1070228 L7.23911383,17.2632004 L6.64171123,16.6303336 L6.78227655,15.4700778 L7.13368984,15.2942814 L7.55538579,15.505237 L7.76623377,15.0833258 L9.06646295,14.8723702 L9.10160428,14.5559368 L8.57448434,13.7824329 L8.53934301,13.395681 L9.31245225,12.4463808 L9.31245225,12.1299473 L9.69900688,12.4112215 L9.90985485,12.0596288 L9.66386555,11.4619213 L11.2803667,11.2861249 L11.3506494,11.7080361 L11.737204,11.7783547 L11.8777693,11.4619213 L11.6669213,11.0048508 L11.7723453,10.7235766 L12.2291826,11.0048508 L12.8265852,10.8642137 L13.4239878,11.0751693 L14.618793,11.8135139 L15.2513369,10.8290544 L16.4812834,10.0555506 L17.5355233,11.2158064 L18.0977846,10.4774618 L18.2032086,9.52816154 L19.5385791,8.71949838 L19.6088617,9.17656886 L20.276547,9.59848007 L21.3307869,9.52816154 L21.7524828,9.28204666 L21.7876241,8.08663156 L22.6661574,6.78573866 L24.2826585,5.23873088 L24.2475172,4.64102333 L24.6692131,3.30497116 L25.4423224,3.65656384 L27.7967914,2.07439679 L27.6562261,1.47668924 L27.1291062,0.738344621 L27.4805195,0.0703185353 L27.9373568,0.246114874 L28.710466,0.281274141 L29.3781513,0 L30.3972498,0.421911212 L31.1703591,1.61732631 L31.1703591,1.96891899 L32.6111536,2.21503386 L33.4194041,2.14471533 L34.0870894,2.88305995 L34.8601986,2.95337848 L34.8601986,2.60178581 L35.5278839,2.32051167 L36.5821238,2.60178581 L37.0038197,2.88305995 L37.460657,2.63694507 L37.776929,2.63694507 L37.9877769,2.03923752 L39.1825821,1.40637071 L39.3582888,1.68764485 L39.6394194,2.70726361 L40.8693659,3.19949336 L41.2910619,3.93783798 L41.2559206,4.32458992 L41.4667685,4.6761826 L41.2559206,5.94191623 L41.9236058,6.50446452 L42.2047364,6.89121646 L42.5561497,7.10217207 L42.5210084,7.41860548 L44.0672269,9.38752447 L44.5592055,9.38752447 L45.0863254,10.0203913 L45.5080214,10.1258691 L46,10.0907098 L44.2780749,12.4112215 L43.2589763,12.7628142 L42.2047364,13.8175922 L42.0641711,14.5910961 L41.3262032,15.0481666 L41.2910619,15.6458741 L40.7990833,16.1381039 L40.1665393,16.3139002 L39.9908327,16.9819263 L39.6394194,17.1225634 L37.2146677,18.5992526 L35.2467532,19.0914823 Z M0.0573975045,23.0409982 L0,22.9734717 L0.016399287,22.8770053 L0.106595365,22.8770053 L0.16399287,22.9445318 L0.139393939,23.0409982 L0.0573975045,23.0409982 Z"
          id="Kentucky"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  'filters-like': (props) => (
    <svg width={16} height={14} viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.554.51a3.528 3.528 0 0 1 2.568.828 3.933 3.933 0 0 1 1.374 2.82 3.958 3.958 0 0 1-1.102 2.948L8.347 13.35 1.603 7.106A3.96 3.96 0 0 1 .505 4.158a3.934 3.934 0 0 1 1.373-2.82A3.53 3.53 0 0 1 4.448.51C5.39.579 6.32 1 7.026 1.73L8 2.735l.975-1.005a4.015 4.015 0 0 1 2.58-1.22z"
        fillRule="nonzero"
        stroke="#FFF"
        fill="currentColor"
      />
    </svg>
  ),
  'filters-like-outline': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M-953-145H487v3730H-953z" />
        <path
          d="M14.447 1.96c-1.703-1.45-4.25-1.21-5.83.421L8 3.02l-.615-.635C6.11 1.066 3.538.272 1.554 1.96-.41 3.634-.512 6.641 1.244 8.453l6.047 6.244a.971.971 0 0 0 1.413 0l6.047-6.244c1.762-1.812 1.659-4.819-.304-6.494zm-.409 5.8-6.025 6.243-6.05-6.244c-1.2-1.237-1.45-3.597.24-5.037 1.713-1.463 3.726-.403 4.463.36L8 4.458l1.335-1.378c.725-.75 2.756-1.812 4.462-.36 1.688 1.438 1.441 3.798.241 5.038z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-location': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.617 15.677C13.157 9.095 14 8.42 14 6A6 6 0 1 0 2 6c0 2.42.843 3.095 5.383 9.677a.75.75 0 0 0 1.234 0zM8 8.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
          fill="currentColor"
          fillOpacity={0.85}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-neighborhood': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M13.748 7.648c.122 0 .24-.008.356-.024 1.631-.218 2.406-2.15 1.533-3.543L13.95 1.39a.832.832 0 0 0-.704-.39H2.752a.832.832 0 0 0-.704.39L.362 4.08C-.508 5.47.264 7.404 1.89 7.625a2.565 2.565 0 0 0 2.273-.836 2.57 2.57 0 0 0 3.834 0 2.57 2.57 0 0 0 3.834 0c.47.522 1.15.86 1.917.86zm.073 6.652a.83.83 0 0 0 .831-.831V8.357c-.14.041-.28.075-.426.093a3.296 3.296 0 0 1-1.24-.068l.001 2.593H3.012V8.383c-.25.057-.507.098-.766.098-.156 0-.315-.01-.468-.03a3.267 3.267 0 0 1-.426-.094v5.112c0 .46.371.831.831.831h11.638z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-new-construction': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="m3.42 7.626 4.206-4.204-1.378-1.38L4.32 3.97a.284.284 0 0 1-.175.073.284.284 0 0 1-.175-.073l-.35-.35a.247.247 0 0 1 0-.35l1.927-1.928L4.496.291a.991.991 0 0 0-1.402 0L.29 3.094a.991.991 0 0 0 0 1.402l3.13 3.13zm10.702-2.211 1.438-1.438a1.501 1.501 0 0 0 0-2.123L14.146.44a1.502 1.502 0 0 0-2.123 0l-1.438 1.437 3.537 3.538zM.78 15.99l3.357-.589 9.279-9.279-3.537-3.537-9.282 9.28-.586 3.357a.663.663 0 0 0 .769.768zm12.127-.28 2.804-2.804a.991.991 0 0 0 0-1.401l-1.052-1.052-1.927 1.928a.247.247 0 0 1-.35 0l-.35-.35a.248.248 0 0 1 0-.35l1.927-1.928-1.38-1.38-4.205 4.205 3.131 3.131a.991.991 0 0 0 1.402 0z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-new-listing': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.6 15.7C13.2 9.1 14 8.4 14 6c0-3.3-2.7-6-6-6S2 2.7 2 6c0 2.4.8 3.1 5.4 9.7.3.4.9.4 1.2 0zm-.35-6.2h-.5a.5.5 0 0 1-.5-.5V6.75H5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h2.25V3a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v2.25H11a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8.75V9a.5.5 0 0 1-.5.5z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-notification': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M13.997 13A1 1 0 0 0 15 12a.976.976 0 0 0-.27-.678c-.603-.65-1.732-1.625-1.732-4.822 0-2.428-1.703-4.372-3.999-4.849V1a1 1 0 1 0-1.998 0v.651c-2.296.477-3.998 2.42-3.998 4.849 0 3.197-1.13 4.173-1.734 4.822A.977.977 0 0 0 1 12a1 1 0 0 0 1.003 1h11.994zM8 16a2 2 0 0 0 2-2H6A2 2 0 0 0 8 16z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-ohio': (props) => (
    <svg width={35} height={39} viewBox="0 0 35 39" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <polygon
          fill="currentColor"
          transform="translate(17.827822, 19.674602) rotate(9.000000) translate(-17.827822, -19.674602) "
          points="11.8330587 7.82780848 12.6240344 7.66153769 13.8729434 8.20191774 14.7471797 8.45132392 15.0385918 8.82543318 15.4548948 8.82543318 15.8711978 8.20191774 16.4123918 8.53445931 17.0368463 8.53445931 16.995216 8.95013627 15.7046766 9.15797475 14.8720706 9.6152194 15.6630463 9.94776097 16.3291312 9.32424553 17.3282584 9.15797475 18.244125 9.78149019 18.8685795 9.73992249 19.909337 9.03327166 21.4080278 8.16035004 23.5728035 8.03564696 25.6126882 5.58315289 27.1946396 4.29455432 31.0662576 2.17460183 33.1061423 14.6033429 32.1902757 15.1021553 32.7730999 15.9750769 32.7314696 16.8895662 32.9812514 17.7209201 32.5233181 19.1342218 32.4816878 21.3788774 32.0653848 22.8753144 32.2735363 23.3325591 32.1070151 24.2470484 31.6490818 24.4548869 30.8164758 25.8266208 30.0671303 26.6579747 29.8173485 26.6579747 29.0680031 27.3646256 28.5268092 26.8658132 27.9023547 27.6140318 27.7774638 28.1128441 27.2362699 28.1128441 26.695076 29.0273334 26.7367063 29.900255 26.3204033 30.1080935 26.9032275 30.5653382 26.9032275 31.3551244 26.4869245 31.4382598 26.1955124 31.7708014 25.7792094 31.9786398 25.5294276 31.1057182 24.8633428 30.8978797 24.4470398 31.8539367 24.3221489 32.7684261 23.8642156 33.3088061 24.4054095 34.8052432 23.780955 35.1377847 23.6144338 36.5926541 22.9899792 36.5926541 21.6578096 37.1746018 21.158246 36.3016802 19.7011855 35.7197325 19.3681431 34.5142693 19.1599916 34.1817277 17.7445614 34.9299462 17.4947796 35.6365971 17.1201069 35.6365971 16.578913 35.9275709 16.0793494 35.5950294 14.8304403 35.2624878 14.0394646 35.5950294 14.0394646 36.0107063 13.123598 35.9275709 12.3326223 35.0546493 11.3751254 35.1377847 9.66828306 34.8468109 9.66828306 34.4311339 8.75241645 33.0178322 7.54513773 32.5190199 6.75416202 32.8515614 5.83829541 32.8099937 5.2971015 32.6021553 2.54950166 8.82543318 11.458386 7.37056382"
        />
      </g>
    </svg>
  ),
  'filters-open-house': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M14.959 9.547a.378.378 0 0 0 .257-.121l.708-.861A.387.387 0 0 0 16 8.353a.378.378 0 0 0-.123-.258L13.555 6.18V2.333A.333.333 0 0 0 13.222 2h-1.556a.333.333 0 0 0-.333.333V4.35L8.846 2.304A1.55 1.55 0 0 0 8 2a1.55 1.55 0 0 0-.847.304L.12 8.094A.378.378 0 0 0 0 8.352c0 .067.034.162.077.213l.708.861c.055.067.17.122.257.122a.387.387 0 0 0 .212-.077L7.788 4.09A.394.394 0 0 1 8 4.014c.066 0 .161.034.213.075l6.534 5.381a.387.387 0 0 0 .212.077zm-2.07 4.895c.245 0 .444-.199.444-.444V9.442l-5.12-4.214A.394.394 0 0 0 8 5.153a.394.394 0 0 0-.212.075L2.667 9.446v4.552c0 .245.199.444.444.444l3.113-.008a.445.445 0 0 0 .442-.444V11.33c0-.245.2-.444.444-.444h1.778c.245 0 .444.199.444.444v2.658c0 .215.153.394.355.435l.09.01 3.111.008z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-photos': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M-300-669h1440v3166H-300z" />
        <path
          d="M14.667 11.778c.736 0 1.333-.597 1.333-1.334v-7.11C16 2.596 15.403 2 14.667 2H4c-.736 0-1.333.597-1.333 1.333v7.111c0 .737.597 1.334 1.333 1.334h10.667zM5.777 6a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667zm8.445 4H4.444V8.667l1.543-1.542c.13-.13.34-.13.471 0l1.098 1.097 3.764-3.764c.13-.13.341-.13.471 0l2.431 2.43V10zM12 14.444c.736 0 1.333-.597 1.333-1.333v-.444H4a2.225 2.225 0 0 1-2.222-2.223V4.667h-.445C.597 4.667 0 5.264 0 6v7.111c0 .736.597 1.333 1.333 1.333H12z"
          fill="currentColor"
          fillOpacity={0.85}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-price-change': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M12.59 14.645a.428.428 0 0 0 .426-.426v-1.285c1.242-.024 2.406-.762 2.817-1.937A2.927 2.927 0 0 0 13.9 7.22l-2.879-.842a.786.786 0 0 1 .221-1.54h1.767c.326 0 .645.098.912.28.162.109.381.082.52-.054l.927-.906a.432.432 0 0 0-.048-.653 3.768 3.768 0 0 0-2.305-.8V1.427A.428.428 0 0 0 12.589 1h-.853a.428.428 0 0 0-.426.426v1.28h-.067a2.92 2.92 0 0 0-2.905 3.187c.112 1.229 1.05 2.228 2.234 2.575l2.732.8a.786.786 0 0 1-.221 1.54h-1.768c-.325 0-.645-.099-.911-.28a.416.416 0 0 0-.52.053l-.927.906a.432.432 0 0 0 .048.653 3.768 3.768 0 0 0 2.305.8v1.28c0 .234.192.425.426.425h.853zM3.92 12.077l3.237-3.238a.398.398 0 0 0 0-.565l-.37-.37a.397.397 0 0 0-.571.007L4.303 9.918V5.131c0-.222-.178-.4-.4-.4h-.532c-.222 0-.4.178-.4.4v4.787L1.059 7.911a.4.4 0 0 0-.572-.007l-.37.37a.398.398 0 0 0 0 .565l3.239 3.238a.398.398 0 0 0 .564 0z" />
        </g>
      </g>
    </svg>
  ),
  'filters-price-range': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M4.444 15.224c.244 0 .444-.2.444-.445V13.44c1.295-.025 2.509-.794 2.937-2.02A3.05 3.05 0 0 0 5.81 7.485l-3-.878A.82.82 0 0 1 3.04 5h1.842c.339 0 .672.103.95.292.17.114.397.086.542-.055l.966-.945a.45.45 0 0 0-.05-.68 3.928 3.928 0 0 0-2.403-.834V1.444c0-.244-.2-.444-.444-.444h-.89c-.244 0-.444.2-.444.444v1.334h-.069A3.044 3.044 0 0 0 .013 6.101C.13 7.38 1.107 8.423 2.34 8.784l2.847.834a.82.82 0 0 1-.23 1.606H3.116c-.339 0-.672-.103-.95-.292a.433.433 0 0 0-.542.055l-.967.945a.45.45 0 0 0 .05.68c.681.534 1.531.831 2.403.834v1.333c0 .245.2.445.445.445h.889zm8 0c.245 0 .445-.2.445-.445V13.44c1.295-.025 2.509-.794 2.937-2.02a3.05 3.05 0 0 0-2.014-3.936l-3-.878A.82.82 0 0 1 11.041 5h1.842c.339 0 .672.103.95.292.17.114.397.086.542-.055l.966-.945a.45.45 0 0 0-.05-.68 3.928 3.928 0 0 0-2.403-.834V1.444c0-.244-.2-.444-.444-.444h-.89c-.244 0-.444.2-.444.444v1.334h-.07a3.044 3.044 0 0 0-3.027 3.323c.116 1.28 1.094 2.322 2.328 2.683l2.847.834a.82.82 0 0 1-.23 1.606h-1.842c-.34 0-.672-.103-.95-.292a.433.433 0 0 0-.542.055l-.967.945a.45.45 0 0 0 .05.68c.68.534 1.531.831 2.403.834v1.333c0 .245.2.445.445.445h.889z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-school-district': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M6.4 14.8v-3.6a.4.4 0 0 1 .4-.4h2.4a.4.4 0 0 1 .4.4v3.6h3.2V5.467a.8.8 0 0 0-.356-.666l-4-2.667A.94.94 0 0 0 8 2a.94.94 0 0 0-.444.134l-4 2.667a.894.894 0 0 0-.356.665V14.8h3.2zM8 8.4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm1-1.2a.2.2 0 0 0 .2-.2v-.4a.2.2 0 0 0-.2-.2h-.6v-1a.2.2 0 0 0-.2-.2h-.4a.2.2 0 0 0-.2.2V7c0 .11.09.2.2.2H9zm-6.6 7.6v-8H.8a.8.8 0 0 0-.8.8v6.8a.4.4 0 0 0 .4.4h2zm13.2 0a.4.4 0 0 0 .4-.4V7.6a.8.8 0 0 0-.8-.8h-1.6v8h2z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-streetview': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M8 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm1 10a1 1 0 0 0 1-1v-3a1 1 0 0 0 1-1V6a1.5 1.5 0 0 0-1.5-1.5h-.369c-.346.157-.727.25-1.131.25s-.785-.093-1.131-.25H6.5A1.5 1.5 0 0 0 5 6v3a1 1 0 0 0 1 1v3a1 1 0 0 0 1 1h2zm-1 2c4.418 0 8-1.343 8-3 0-1.186-1.84-2.208-4.503-2.695a1.998 1.998 0 0 1-.497.427v.716c2.079.292 3.5.877 3.5 1.552 0 .967-2.91 1.75-6.5 1.75S1.5 13.967 1.5 13c0-.675 1.421-1.26 3.5-1.552v-.716a1.998 1.998 0 0 1-.497-.427C1.84 10.792 0 11.815 0 13c0 1.657 3.582 3 8 3z"
          fill="currentColor"
          fillOpacity={0.85}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'filters-search': (props) => (
    <svg
      width="16px"
      height="11px"
      viewBox="0 0 16 11"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="icons-filters-search" fill="currentColor" fillRule="nonzero">
          <path
            d="M0,11 L0,9.20797227 L7.73485714,9.20797227 L7.73485714,11 L0,11 Z M0,6.78682842 L0,4.99480069 L4.49828571,4.99480069 L4.49828571,6.78682842 L0,6.78682842 Z M0,2.57365685 L0,0.762564991 L4.49828571,0.762564991 L4.49828571,2.57365685 L0,2.57365685 Z M14.9211429,10.6377816 L11.9561143,7.54939341 C11.6350781,7.80358174 11.2891429,7.99104564 10.9183086,8.1117851 C10.5474621,8.23252455 10.162883,8.29289428 9.76457143,8.29289428 C8.66169905,8.29289428 7.7216,7.88890006 6.94427429,7.08091161 C6.16694857,6.27292317 5.77828571,5.29574697 5.77828571,4.14938302 C5.77828571,3.00300635 6.16671695,2.02485153 6.94357943,1.21491854 C7.7204541,0.404972848 8.65867581,0 9.75824457,0 C10.8578011,0 11.7950781,0.405207972 12.5700754,1.21562392 C13.3450728,2.02603986 13.7325714,3.00615829 13.7325714,4.1559792 C13.7325714,4.57124668 13.6746667,4.97373484 13.5588571,5.36344367 C13.4430476,5.75315251 13.2632381,6.11029983 13.0194286,6.43488562 L16,9.53206239 L14.9211429,10.6377816 Z M9.76457143,6.71057192 C10.440131,6.71057192 11.0173989,6.46198845 11.4963749,5.96482149 C11.975363,5.46766724 12.2148571,4.86396996 12.2148571,4.15372964 C12.2148571,3.44350202 11.9764236,2.83737724 11.4995566,2.33535529 C11.0227017,1.83333333 10.4436541,1.58232236 9.76241371,1.58232236 C9.08118552,1.58232236 8.50285714,1.83220855 8.02742857,2.33198094 C7.552,2.83176603 7.31428571,3.43864702 7.31428571,4.15262392 C7.31428571,4.8665881 7.5525059,5.47140381 8.02894629,5.96707106 C8.50539886,6.4627383 9.08394057,6.71057192 9.76457143,6.71057192 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  ),
  'filters-video': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M9.339 13.667c.733 0 1.328-.595 1.328-1.328V4.328c0-.734-.595-1.328-1.328-1.328H1.328C.594 3 0 3.594 0 4.328v8.01c0 .734.594 1.329 1.328 1.329h8.01zM16 11.9V4.764c0-.706-.808-1.122-1.4-.717l-3.044 2.1v4.372l3.044 2.098c.589.405 1.4-.009 1.4-.717z"
          fill="currentColor"
          fillOpacity={0.85}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  'social-facebook': (props) => (
    <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.723 0H1.664C1.08 0 .606.474.606 1.06v17.08c0 .586.474 1.06 1.058 1.06h9.19v-7.425H8.36V8.868h2.496V6.73c0-2.48 1.514-3.83 3.722-3.83.745-.002 1.488.036 2.229.112v2.592h-1.521c-1.203 0-1.438.57-1.438 1.41v1.851h2.876l-.374 2.907H13.83V19.2h4.893c.584 0 1.058-.474 1.058-1.06V1.06c0-.586-.474-1.06-1.058-1.06z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
  'social-instagram': (props) => (
    <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.031.001c.966.003 1.467.01 1.919.024l.192.007c.19.007.384.015.61.026 1.021.046 1.718.209 2.328.446.63.245 1.165.574 1.698 1.107.533.534.861 1.07 1.106 1.7.237.611.4 1.31.446 2.33l.03.709.005.194c.014.461.02 1.002.022 2.038v2.036a71.161 71.161 0 0 1-.025 2.136l-.006.192c-.007.191-.016.385-.026.612-.047 1.022-.209 1.72-.446 2.33a4.707 4.707 0 0 1-1.106 1.7 4.7 4.7 0 0 1-1.698 1.108c-.61.237-1.307.4-2.327.446-.947.043-1.297.056-3.41.058H9.257c-2.114-.002-2.464-.015-3.41-.058-1.021-.046-1.718-.209-2.328-.446a4.7 4.7 0 0 1-1.698-1.107 4.706 4.706 0 0 1-1.106-1.7c-.237-.611-.4-1.31-.446-2.33-.01-.228-.019-.422-.026-.613l-.006-.192a65.074 65.074 0 0 1-.024-1.921V8.367a69.75 69.75 0 0 1 .02-1.823l.007-.194c.008-.224.017-.443.03-.708.046-1.022.208-1.72.445-2.33a4.706 4.706 0 0 1 1.106-1.7A4.699 4.699 0 0 1 3.52.503c.61-.237 1.307-.4 2.327-.446.227-.01.42-.02.611-.026L6.65.025C7.102.011 7.603.004 8.57.001zm-.945 1.729H8.768a65.287 65.287 0 0 0-2.122.026l-.194.007c-.163.006-.332.014-.526.023-.935.042-1.443.199-1.78.33a2.97 2.97 0 0 0-1.103.718 2.974 2.974 0 0 0-.717 1.104c-.131.338-.287.847-.33 1.783-.037.817-.05 1.173-.055 2.63v2.498c.004 1.457.018 1.813.055 2.63.043.936.199 1.445.33 1.783.174.448.382.768.717 1.104a2.97 2.97 0 0 0 1.103.718c.337.131.845.288 1.78.33.894.041 1.234.054 3.073.056h1.602c1.839-.002 2.179-.015 3.073-.056.935-.042 1.443-.199 1.78-.33a2.97 2.97 0 0 0 1.103-.718c.335-.336.543-.656.717-1.104.131-.338.287-.847.33-1.783.01-.233.02-.43.026-.624l.007-.195c.015-.495.021-1.058.022-2.258V8.798c-.002-1.84-.014-2.182-.055-3.077-.043-.936-.199-1.445-.33-1.783a2.974 2.974 0 0 0-.717-1.104 2.97 2.97 0 0 0-1.103-.718c-.337-.131-.845-.288-1.78-.33a80.404 80.404 0 0 0-.526-.023l-.194-.007a65.286 65.286 0 0 0-2.122-.025l-.48-.001H9.8zM9.8 4.67a4.926 4.926 0 0 1 4.923 4.93A4.926 4.926 0 0 1 9.8 14.53 4.926 4.926 0 0 1 4.877 9.6 4.926 4.926 0 0 1 9.8 4.67zm0 1.73a3.198 3.198 0 0 1 3.196 3.2c0 1.767-1.431 3.2-3.196 3.2a3.198 3.198 0 0 1-3.196-3.2c0-1.767 1.431-3.2 3.196-3.2zm5.118-3.077a1.151 1.151 0 1 1-.002 2.303 1.151 1.151 0 0 1 .002-2.303z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
  'social-linkedin': (props) => (
    <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.159 16.36h-2.843v-4.456c0-1.062-.02-2.429-1.48-2.429-1.478 0-1.704 1.159-1.704 2.353v4.533h-2.84V7.198h2.724V8.45h.04c.38-.72 1.307-1.48 2.69-1.48 2.881 0 3.413 1.897 3.413 4.365v5.026zM5.084 5.948a1.65 1.65 0 1 1 0-3.302 1.65 1.65 0 0 1 0 3.302zM3.66 16.36h2.848V7.198H3.659v9.163zM18.575 0H2.233C1.453 0 .819.62.819 1.385v16.43c0 .764.634 1.385 1.414 1.385h16.342c.782 0 1.419-.62 1.419-1.386V1.384C19.994.62 19.357 0 18.574 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
  'social-x': (props) => (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="logo" fill="currentColor" fillRule="nonzero">
          <path
            d="M11.9027167,8.46863508 L19.3481667,0 L17.5838333,0 L11.11895,7.35319683 L5.95546667,0 L0,0 L7.8082,11.1193359 L0,20 L1.76443333,20 L8.59151667,12.2347742 L14.0445333,20 L20,20 L11.9022833,8.46863508 L11.9027167,8.46863508 Z M9.48608333,11.2172998 L8.69495,10.1100647 L2.40018333,1.29967954 L5.11025,1.29967954 L10.1902,8.40994153 L10.9813333,9.51717671 L17.5846667,18.7594282 L14.8746,18.7594282 L9.48608333,11.2177239 L9.48608333,11.2172998 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  ),
  'social-pinterest': (props) => (
    <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.38 0A8 8 0 0 0 .382 8a8.005 8.005 0 0 0 5.085 7.453c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.48-.239-1.188c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.713-.663 2.664-.188.796.4 1.445 1.185 1.445 1.422 0 2.515-1.499 2.515-3.663 0-1.916-1.377-3.255-3.342-3.255-2.276 0-3.612 1.707-3.612 3.472 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23l-.223.906c-.034.147-.115.178-.267.108-1-.466-1.624-1.927-1.624-3.1 0-2.524 1.834-4.841 5.286-4.841 2.775 0 4.932 1.977 4.932 4.62 0 2.758-1.739 4.977-4.151 4.977-.811 0-1.573-.422-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 0 0 16.381 8a8 8 0 0 0-8-8"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
  'social-tiktok': (props) => (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.1011 4.63516C15.9745 4.56975 15.8513 4.49804 15.7319 4.42031C15.3848 4.1908 15.0665 3.92037 14.7839 3.61484C14.0768 2.80586 13.8128 1.98516 13.7155 1.41055H13.7194C13.6382 0.933594 13.6718 0.625 13.6769 0.625H10.4565V13.0773C10.4565 13.2445 10.4565 13.4098 10.4495 13.573C10.4495 13.5934 10.4476 13.6121 10.4464 13.634C10.4464 13.643 10.4464 13.6523 10.4444 13.6617C10.4444 13.6641 10.4444 13.6664 10.4444 13.6687C10.4105 14.1155 10.2673 14.5471 10.0274 14.9256C9.78746 15.304 9.45824 15.6177 9.06865 15.8391C8.66261 16.0701 8.20337 16.1912 7.73623 16.1906C6.23583 16.1906 5.01982 14.9672 5.01982 13.4562C5.01982 11.9453 6.23583 10.7219 7.73623 10.7219C8.02024 10.7216 8.30251 10.7663 8.57255 10.8543L8.57646 7.57539C7.75668 7.4695 6.92385 7.53465 6.13051 7.76673C5.33717 7.99882 4.60054 8.3928 3.96708 8.92383C3.41203 9.40609 2.9454 9.98152 2.58818 10.6242C2.45224 10.8586 1.93935 11.8004 1.87724 13.3289C1.83818 14.1965 2.09873 15.0953 2.22294 15.4668V15.4746C2.30107 15.6934 2.6038 16.4398 3.09716 17.0691C3.49499 17.5739 3.96501 18.0174 4.49208 18.3852V18.3773L4.4999 18.3852C6.05888 19.4445 7.7874 19.375 7.7874 19.375C8.08662 19.3629 9.08896 19.375 10.2272 18.8355C11.4897 18.2375 12.2085 17.3465 12.2085 17.3465C12.6677 16.8141 13.0328 16.2074 13.2882 15.5523C13.5796 14.7863 13.6769 13.8676 13.6769 13.5004V6.89414C13.7159 6.91758 14.2362 7.26172 14.2362 7.26172C14.2362 7.26172 14.9858 7.74219 16.1554 8.05508C16.9944 8.27773 18.1249 8.32461 18.1249 8.32461V5.12773C17.7288 5.1707 16.9245 5.0457 16.1011 4.63516Z"
        fill="currentColor"
      />
    </svg>
  ),
  'map-recenter': (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
      <path d="M272 137.4L324.7 84.69C330.9 78.44 341.1 78.44 347.3 84.69C353.6 90.93 353.6 101.1 347.3 107.3L267.3 187.3C261.1 193.6 250.9 193.6 244.7 187.3L164.7 107.3C158.4 101.1 158.4 90.93 164.7 84.69C170.9 78.44 181.1 78.44 187.3 84.69L240 137.4V16C240 7.164 247.2 0 256 0C264.8 0 272 7.164 272 16L272 137.4zM288 256C288 273.7 273.7 288 256 288C238.3 288 224 273.7 224 256C224 238.3 238.3 224 256 224C273.7 224 288 238.3 288 256zM324.7 427.3L272 374.6V496C272 504.8 264.8 512 256 512C247.2 512 240 504.8 240 496V374.6L187.3 427.3C181.1 433.6 170.9 433.6 164.7 427.3C158.4 421.1 158.4 410.9 164.7 404.7L244.7 324.7C250.9 318.4 261.1 318.4 267.3 324.7L347.3 404.7C353.6 410.9 353.6 421.1 347.3 427.3C341.1 433.6 330.9 433.6 324.7 427.3L324.7 427.3zM84.69 164.7C90.94 158.4 101.1 158.4 107.3 164.7L187.3 244.7C193.6 250.9 193.6 261.1 187.3 267.3L107.3 347.3C101.1 353.6 90.94 353.6 84.69 347.3C78.44 341.1 78.44 330.9 84.69 324.7L137.4 271.1H16C7.165 271.1 .0019 264.8 .0019 255.1C.0019 247.2 7.165 239.1 16 239.1H137.4L84.69 187.3C78.44 181.1 78.44 170.9 84.69 164.7L84.69 164.7zM427.3 187.3L374.6 239.1H496C504.8 239.1 512 247.2 512 255.1C512 264.8 504.8 271.1 496 271.1H374.6L427.3 324.7C433.6 330.9 433.6 341.1 427.3 347.3C421.1 353.6 410.9 353.6 404.7 347.3L324.7 267.3C318.4 261.1 318.4 250.9 324.7 244.7L404.7 164.7C410.9 158.4 421.1 158.4 427.3 164.7C433.6 170.9 433.6 181.1 427.3 187.3L427.3 187.3z" />
    </svg>
  ),
  'map-house': (props) => (
    <svg
      width="30px"
      height="40px"
      viewBox="0 0 30 40"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{'location-pin-solid'}</title>
      <g id="House-Marker" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="location-pin-solid" fillRule="nonzero">
          <path
            d="M30,15.0389191 C30,21.8847604 20.859375,34.072551 16.8515625,39.1011896 C15.890625,40.2996035 14.109375,40.2996035 13.1484375,39.1011896 C9.140625,34.072551 0,21.8847604 0,15.0389191 C0,6.7361825 6.71875,0 15,0 C23.28125,0 30,6.7361825 30,15.0389191 Z"
            id="Path"
            fill="#C80002"
          />
          <g id="icons-filters-open-house" transform="translate(5.000000, 7.000000)" fill="#FFFFFF">
            <path
              d="M17.7638125,9.12645029 C17.8803536,9.1199361 17.9898205,9.06745187 18.069,8.98012719 L18.90975,7.93893549 C18.9641253,7.86448023 18.9955391,7.77524505 19,7.68256774 C18.9932873,7.56311044 18.9408469,7.45109569 18.8539375,7.37057301 L16.0965625,5.05479823 L16.0965625,0.402690864 C16.0965625,0.295890606 16.0549005,0.193464609 15.9807415,0.117945423 C15.9065826,0.042426237 15.8060015,0 15.701125,0 L13.853375,0 C13.7484985,0 13.6479174,0.042426237 13.5737585,0.117945423 C13.4995995,0.193464609 13.4579375,0.295890606 13.4579375,0.402690864 L13.4579375,2.8418124 L10.504625,0.367621689 C10.212764,0.146709542 9.86318366,0.018787847 9.5,0 C9.1364063,0.0185518039 8.78638046,0.146485279 8.4941875,0.367621689 L0.1425,7.36936373 C0.0569083155,7.45049152 0.00578213701,7.56242905 0,7.68135845 C0,7.76238034 0.040375,7.87726212 0.0914375,7.93893549 L0.9321875,8.98012719 C0.9975,9.06114907 1.1340625,9.12765957 1.237375,9.12765957 C1.32850914,9.12276483 1.4161487,9.09034961 1.489125,9.03454487 L9.24825,2.52739911 C9.3215983,2.47247291 9.40908976,2.44053274 9.5,2.43549369 C9.578375,2.43549369 9.6911875,2.47660928 9.7529375,2.52618983 L17.5120625,9.03333559 C17.5850388,9.08914033 17.6726784,9.12155555 17.7638125,9.12645029 Z M15.7913907,14.4660809 L15.7913907,8.98739759 L9.72107756,3.91997627 C9.64737845,3.86556593 9.55959412,3.83421503 9.46854305,3.82978723 C9.37790091,3.83444634 9.29055992,3.86578604 9.21719414,3.91997627 L3.14569536,8.99220767 L3.14569536,14.4660809 C3.14569536,14.7606984 3.38163136,15 3.67210533,15 L7.36290317,14.9903798 C7.65243444,14.9884008 7.88629785,14.7501281 7.88694192,14.4564607 L7.88694192,11.2577563 C7.88694192,10.9631387 8.12406353,10.7238372 8.41335189,10.7238372 L10.521363,10.7238372 C10.811837,10.7238372 11.047773,10.9631387 11.047773,11.2577563 L11.047773,14.4540557 C11.047773,14.7125976 11.229171,14.9278488 11.4686638,14.9771521 L11.5753685,14.9891773 L15.2637952,14.9987975 C15.5554547,15 15.7913907,14.7606984 15.7913907,14.4660809 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  'map-default-marker': (props) => (
    <svg
      width="43px"
      height="30px"
      viewBox="0 0 43 30"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{'Group Copy'}</title>
      <g id="Similar-Property-Marker" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-Copy" transform="translate(0.000000, 0.000000)" fill="#262626">
          <g id="icons-map-marker" fillRule="nonzero">
            <polygon
              id="Path"
              points="43 0 0 0 0 24.4673624 16.2 24.4673624 22.1 27.3124045 27.9 24.4673624 43 24.4673624"
            />
          </g>
          <polygon
            id="Rectangle"
            transform="translate(22.000000, 24.277693) rotate(-45.000000) translate(-22.000000, -24.277693) "
            points="18 20.2776929 26.0462822 20.2314108 26 28.2776929 17.9537178 28.3239751"
          />
        </g>
      </g>
    </svg>
  ),
  'map-new-price-marker': (props) => (
    <svg
      width="47px"
      height="34px"
      viewBox="0 0 47 34"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{'Group 5'}</title>
      <g id="Similar-Property-Marker" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-5" transform="translate(0.000000, 0.000000)">
          <g id="Group-Copy-4" transform="translate(0.000000, 4.000000)" fill="#282828">
            <g id="icons-map-marker" fillRule="nonzero">
              <polygon
                id="Path"
                points="43 0 0 0 0 24.4673624 16.2 24.4673624 22.1 27.3124045 27.9 24.4673624 43 24.4673624"
              />
            </g>
            <polygon
              id="Rectangle"
              transform="translate(22.000000, 24.277693) rotate(-45.000000) translate(-22.000000, -24.277693) "
              points="18 20.2776929 26.0462822 20.2314108 26 28.2776929 17.9537178 28.3239751"
            />
          </g>
          <circle id="Oval-Copy-3" fill="#A2C6A8" cx={41} cy={6} r={6} />
        </g>
      </g>
    </svg>
  ),
  'map-office-marker': (props) => (
    <svg
      width="30px"
      height="40px"
      viewBox="0 0 30 40"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Office-Marker" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group" fillRule="nonzero">
          <path
            d="M30,15.0389191 C30,21.8847604 20.859375,34.072551 16.8515625,39.1011896 C15.890625,40.2996035 14.109375,40.2996035 13.1484375,39.1011896 C9.140625,34.072551 0,21.8847604 0,15.0389191 C0,6.7361825 6.71875,0 15,0 C23.28125,0 30,6.7361825 30,15.0389191 Z"
            id="Path-Copy-5"
            fill="#C80002"
          />
          <g id="Favicon_flame-(1)" transform="translate(8.000000, 5.000000)" fill="#fff">
            <path
              d="M0.298178294,17.0612245 C0.447267441,17.6598639 0.745445736,19.1564626 1.93815891,20.3537415 C2.68360465,21.2517007 3.57813953,21.7006803 4.17449612,22 C4.02540697,21.2517007 3.87631783,20.6530612 3.87631783,19.9047619 C3.87631783,17.5102041 5.069031,15.5646259 6.41083333,15.5646259 C7.75263565,15.5646259 8.94534883,17.5102041 8.94534883,19.9047619 C8.94534883,20.6530612 8.79625968,21.4013605 8.64717054,22 C9.24352712,21.7006803 12.8216667,19.0068027 12.9707558,14.6666667 C13.1198449,13.0204082 12.6725775,11.5238095 12.2253101,10.7755102 L12.0762209,10.6258503 C11.6289535,9.72789116 11.0325969,8.97959184 10.4362403,8.23129252 C8.34899224,5.83673469 7.30536821,2.99319728 7.30536821,0 C5.66538759,1.49659864 4.32358527,3.29251701 3.13087209,5.23809524 C1.63998062,7.63265306 0.596356589,10.1768707 0.149089147,13.0204082 C0,13.6190476 0,14.0680272 0,14.6666667 C0,15.414966 0,16.1632653 0.298178294,17.0612245"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  'map-open-marker': (props) => (
    <svg
      width="47px"
      height="34px"
      viewBox="0 0 47 34"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{'Group 3'}</title>
      <g id="Similar-Property-Marker" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-3" transform="translate(0.000000, 0.000000)">
          <g id="Group-Copy-2" transform="translate(0.000000, 4.000000)" fill="#262626">
            <g id="icons-map-marker" fillRule="nonzero">
              <polygon
                id="Path"
                points="43 0 0 0 0 24.4673624 16.2 24.4673624 22.1 27.3124045 27.9 24.4673624 43 24.4673624"
              />
            </g>
            <polygon
              id="Rectangle"
              transform="translate(22.000000, 24.277693) rotate(-45.000000) translate(-22.000000, -24.277693) "
              points="18 20.2776929 26.0462822 20.2314108 26 28.2776929 17.9537178 28.3239751"
            />
          </g>
          <circle id="Oval" fill="#F3DE9B" cx={41} cy={6} r={6} />
        </g>
      </g>
    </svg>
  ),
  'map-pending-marker': (props) => (
    <svg
      width="47px"
      height="34px"
      viewBox="0 0 47 34"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{'Group 4'}</title>
      <g id="Similar-Property-Marker" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-4" transform="translate(0.000000, 0.000000)">
          <g id="Group-Copy-3" transform="translate(0.000000, 4.000000)" fill="#262626">
            <g id="icons-map-marker" fillRule="nonzero">
              <polygon
                id="Path"
                points="43 0 0 0 0 24.4673624 16.2 24.4673624 22.1 27.3124045 27.9 24.4673624 43 24.4673624"
              />
            </g>
            <polygon
              id="Rectangle"
              transform="translate(22.000000, 24.277693) rotate(-45.000000) translate(-22.000000, -24.277693) "
              points="18 20.2776929 26.0462822 20.2314108 26 28.2776929 17.9537178 28.3239751"
            />
          </g>
          <circle id="Oval-Copy-2" fill="#EA9B9B" cx={41} cy={6} r={6} />
        </g>
      </g>
    </svg>
  ),
  'map-sold-marker': (props) => (
    <svg
      width="43px"
      height="30px"
      viewBox="0 0 43 30"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Similar-Property-Marker" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Group-Copy-5" transform="translate(0.000000, 0.000000)" fill="#88898A">
          <g id="icons-map-marker" fillRule="nonzero">
            <polygon
              id="Path"
              points="43 0 0 0 0 24.4673624 16.2 24.4673624 22.1 27.3124045 27.9 24.4673624 43 24.4673624"
            />
          </g>
          <polygon
            id="Rectangle"
            transform="translate(22.000000, 24.277693) rotate(-45.000000) translate(-22.000000, -24.277693) "
            points="18 20.2776929 26.0462822 20.2314108 26 28.2776929 17.9537178 28.3239751"
          />
        </g>
      </g>
    </svg>
  ),
  'general-account': (props) => (
    <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.836 0c2.6 0 4.72 2.12 4.72 4.72a4.72 4.72 0 0 1-2.032 3.876A7.797 7.797 0 0 1 15.627 16l-1.603-.045a6.176 6.176 0 0 0-6.188-6.188C4.41 9.767 1.648 12.53 1.603 16L0 15.955c0-3.372 2.149-6.259 5.148-7.36A4.72 4.72 0 0 1 3.116 4.72c0-2.6 2.12-4.72 4.72-4.72zm0 1.648A3.062 3.062 0 0 0 4.765 4.72a3.062 3.062 0 0 0 3.071 3.07 3.062 3.062 0 0 0 3.071-3.07 3.062 3.062 0 0 0-3.071-3.072z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
  'general-house': (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M1.44,15.38V5.54l6.6-4.92l6.52,4.92v9.84h-4.8V9.54H6.22v5.84H1.44z M2.67,14.15h2.32V8.31h6.01v5.84h2.34v-8l-5.29-4 l-5.37,4V14.15z" />
    </svg>
  ),
  'general-calendar': (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M6.93,12.44L4.26,10l0.81-0.75l1.86,1.68l3.56-3.28l0.81,0.77L6.93,12.44z M0.87,15.08V1.89h2.42V0.82h1.26v1.07h6.58V0.82 h1.26v1.07h2.42v13.2H0.87z M2.04,14.01h11.61V6.35H2.04V14.01z M2.04,5.28h11.61V2.96H2.04V5.28z M2.04,5.28V2.96V5.28z" />
    </svg>
  ),
  'general-key': (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M4.31,9.11c-0.31,0-0.57-0.11-0.79-0.33S3.2,8.31,3.2,8c0-0.31,0.11-0.57,0.33-0.79s0.48-0.33,0.79-0.33S4.88,6.99,5.1,7.21 C5.32,7.43,5.43,7.69,5.43,8c0,0.31-0.11,0.57-0.33,0.79C4.88,9.01,4.62,9.11,4.31,9.11z M4.31,11.94c-1.09,0-2.02-0.38-2.79-1.15 C0.76,10.02,0.38,9.09,0.38,8s0.38-2.02,1.15-2.79c0.77-0.77,1.7-1.15,2.79-1.15c0.79,0,1.48,0.19,2.07,0.56 c0.59,0.37,1.06,0.94,1.39,1.69h5.84l1.85,1.85l-2.74,2.51l-1.44-1.05l-1.44,1.05L8.61,9.69H7.78c-0.27,0.66-0.7,1.19-1.29,1.62 S5.18,11.94,4.31,11.94z M4.31,10.95c0.63,0,1.22-0.21,1.76-0.63C6.61,9.9,6.95,9.36,7.1,8.7h1.87l0.89,0.74l1.44-1.03l1.35,1.02 l1.39-1.3l-0.84-0.84H7.1C6.97,6.68,6.64,6.15,6.12,5.71c-0.53-0.44-1.13-0.66-1.8-0.66c-0.82,0-1.52,0.29-2.09,0.86 S1.36,7.18,1.36,8s0.29,1.52,0.86,2.09C2.8,10.67,3.49,10.95,4.31,10.95z" />
    </svg>
  ),
  'general-clock': (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M10.55,11.34l0.78-0.78L8.57,7.79V4.31H7.53v3.9L10.55,11.34z M8,14.93c-0.95,0-1.84-0.18-2.68-0.55s-1.58-0.86-2.21-1.49 c-0.63-0.63-1.13-1.37-1.49-2.21C1.25,9.84,1.07,8.95,1.07,8s0.18-1.84,0.55-2.68s0.86-1.58,1.49-2.21s1.37-1.13,2.21-1.49 S7.05,1.07,8,1.07s1.84,0.18,2.68,0.55c0.84,0.36,1.58,0.86,2.21,1.49c0.63,0.63,1.13,1.37,1.49,2.21S14.93,7.05,14.93,8 s-0.18,1.84-0.55,2.68c-0.36,0.84-0.86,1.58-1.49,2.21c-0.63,0.63-1.37,1.13-2.21,1.49C9.84,14.75,8.95,14.93,8,14.93z M8,13.89 c1.62,0,3-0.58,4.16-1.73S13.89,9.62,13.89,8s-0.58-3-1.73-4.16S9.62,2.11,8,2.11S5,2.69,3.84,3.84S2.11,6.38,2.11,8 s0.58,3,1.73,4.16S6.38,13.89,8,13.89z" />
    </svg>
  ),
  'general-flame': (props) => (
    <svg
      width="16"
      height="27"
      viewBox="0 0 16 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.366989 20.9388C0.550483 21.6735 0.917472 23.5102 2.38543 24.9796C3.3029 26.0816 4.40386 26.6327 5.13784 27C4.95435 26.0816 4.77085 25.3469 4.77085 24.4286C4.77085 21.4898 6.23881 19.102 7.89026 19.102C9.54171 19.102 11.0097 21.4898 11.0097 24.4286C11.0097 25.3469 10.8262 26.2653 10.6427 27C11.3766 26.6327 15.7805 23.3265 15.964 18C16.1475 15.9796 15.597 14.1429 15.0465 13.2245L14.863 13.0408C14.3126 11.9388 13.5786 11.0204 12.8446 10.102C10.2757 7.16327 8.99122 3.67347 8.99122 0C6.97279 1.83673 5.32134 4.04082 3.85338 6.42857C2.01844 9.36735 0.733977 12.4898 0.183494 15.9796C0 16.7143 0 17.2653 0 18C0 18.9184 0 19.8367 0.366989 20.9388Z"
        fill="#C80002"
      />
    </svg>
  ),
  'general-agent': (props) => (
    <svg
      data-slot="icon"
      fill="currentColor"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.735 14c.618 0 1.093-.561.872-1.139a6.002 6.002 0 0 0-11.215 0c-.22.578.254 1.139.872 1.139h9.47Z"></path>
    </svg>
  ),
  'general-team': (props) => (
    <svg
      data-slot="icon"
      fill="currentColor"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path d="M8 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM3.156 11.763c.16-.629.44-1.21.813-1.72a2.5 2.5 0 0 0-2.725 1.377c-.136.287.102.58.418.58h1.449c.01-.077.025-.156.045-.237ZM12.847 11.763c.02.08.036.16.046.237h1.446c.316 0 .554-.293.417-.579a2.5 2.5 0 0 0-2.722-1.378c.374.51.653 1.09.813 1.72ZM14 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM3.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5 13c-.552 0-1.013-.455-.876-.99a4.002 4.002 0 0 1 7.753 0c.136.535-.324.99-.877.99H5Z"></path>
    </svg>
  )
};

export default IconMap;
